import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div style={{ paddingTop: 64 }}>
      <section style={{
        padding: '80px 32px 60px',
        borderBottom: '1px solid var(--border)',
        background: 'linear-gradient(180deg, rgba(255,46,166,0.04) 0%, transparent 100%)',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{
            fontFamily: 'DM Mono', fontSize: 18, letterSpacing: 4,
            color: 'var(--pink)', textTransform: 'uppercase', marginBottom: 12,
          }}>
            OG-TECH LLC
          </div>
          <h1 style={{
            fontFamily: 'Bomber Dreams', fontSize: 'clamp(48px, 8vw, 80px)',
            letterSpacing: 3, marginBottom: 16,
          }}>
            About the Shop
          </h1>
          <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 520, lineHeight: 1.7, margin: '0 auto' }}>
            Everything here is made or curated by OG-TECH LLC. San Antonio built. No middlemen.
          </p>
          <img src="/images/OG-Tech Logo.png" alt="OG-TECH"
            style={{ width: 'clamp(300px, 40vw, 500px)', display: 'block', margin: '24px auto 0', filter: 'drop-shadow(0 0 30px rgba(0,240,255,0.35))' }} />
        </div>
      </section>

      <section style={{ padding: '80px 32px', textAlign: 'center' }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <div style={{
            fontFamily: 'DM Mono', fontSize: 18, letterSpacing: 4,
            color: 'var(--teal)', textTransform: 'uppercase', marginBottom: 12,
          }}>
            In-House
          </div>
          <h2 style={{ fontFamily: 'Bomber Dreams', fontSize: 44, letterSpacing: 2, marginBottom: 20 }}>
            Built by Us
          </h2>
          <p style={{ fontSize: 15, color: 'var(--muted)', lineHeight: 1.8, marginBottom: 32 }}>
            Merch is printed and assembled in-house. Fabrication parts are built to order at our San Antonio shop.
            No drop shippers, no third party fulfillment. What you order, we make.
          </p>
          <Link to="/" style={{
            fontFamily: 'DM Mono', fontSize: 12, letterSpacing: 2,
            textTransform: 'uppercase', padding: '13px 30px', borderRadius: 8,
            background: 'var(--teal)', color: '#000',
          }}>
            Shop Now →
          </Link>
        </div>
      </section>
    </div>
  );
}
